import React from 'react';
import { motion } from 'framer-motion';
// import InteractiveMap from '../components/InteractiveMap'; // Removed as it's not in the new content
import WhatsAppConnect from '../components/whatsappConnect';

const PageNavbar = () => (
  <nav className="fixed top-0 w-full bg-white shadow-md z-50 flex items-center justify-between px-6 h-24 overflow-hidden">
    <img src="/Hydrocawach_logo.png" alt="HydroCawach Logo" className="h-36 w-auto object-contain" />
    <h1 className="absolute left-1/2 transform -translate-x-1/2 text-blue-600 text-lg md:text-2xl font-bold text-center">
      Bioreactors & Fermentation
    </h1>
  </nav>
);

// --- DATA FOR KEY BENEFITS ---
const keyBenefits = [
  {
    icon: '⚡',
    title: 'Enhanced Oxygen Transfer',
    description: 'Improves aerobic fermentation and microbial growth.'
  },
  {
    icon: '💧',
    title: 'Uniform Mixing',
    description: 'Eliminates dead zones and ensures nutrient homogeneity.'
  },
  {
    icon: '🔄',
    title: 'Cell Disruption',
    description: 'Enables efficient metabolite release and enzyme extraction.'
  },
  {
    icon: '🌱',
    title: 'Eco-Friendly & Energy-Efficient',
    description: 'No chemicals or moving parts.'
  },
  {
    icon: '⚙️',
    title: 'Scalable Integration',
    description: 'Suitable for lab to industrial bioprocesses.'
  }
];

// --- DATA FOR APPLICATIONS ---
const applications = [
  {
    title: 'Biofuel Production',
    description: 'Boosts ethanol, biogas, and biodiesel yield.'
  },
  {
    title: 'Waste-to-Energy Systems',
    description: 'Accelerates anaerobic digestion and methane generation.'
  },
  {
    title: 'Pharma & Enzyme Processes',
    description: 'Enhances cell lysis and product recovery.'
  }
];

const BioreactorsAndFermentation = () => (
  <div className="bg-white text-gray-800 min-h-screen relative overflow-x-hidden">
    <PageNavbar />

    <div className="pt-32 px-4"> {/* Increased top padding */}
      <div className="p-8 max-w-6xl mx-auto">

        {/* Introduction Paragraph */}
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-lg text-center text-gray-700 max-w-4xl mx-auto mb-16"
        >
          Cavitation technology revolutionizes bioreactors and fermentation by enhancing mixing,
          oxygen transfer, and nutrient distribution without mechanical agitation.
          Controlled hydrodynamic cavitation generates micro-turbulence and
          shockwaves that improve mass transfer and microbial activity, leading to faster fermentation and higher yields.
        </motion.p>

        {/* Key Benefits Section */}
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">Key Benefits</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20">
          {keyBenefits.map((benefit, index) => (
            <motion.div
              key={benefit.title}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              // Use lg:grid-cols-3 to allow easy wrapping for 5 items
              className="bg-white border border-gray-200 rounded-lg shadow-lg p-6 flex flex-col items-center text-center hover:shadow-xl transition-shadow duration-300"
            >
              <div className="text-5xl mb-4">{benefit.icon}</div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">{benefit.title}</h3>
              <p className="text-gray-700">{benefit.description}</p>
            </motion.div>
          ))}
        </div>

        {/* Applications Section */}
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">Applications</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20">
          {applications.map((app, index) => (
            <motion.div
              key={app.title}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-green-50 border-l-4 border-green-600 rounded-r-lg shadow-md p-6"
            >
              <h3 className="text-xl font-bold text-green-800 mb-2">{app.title}</h3>
              <p className="text-gray-700">{app.description}</p>
            </motion.div>
          ))}
        </div>

        {/* Final Summary Paragraph */}
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
          className="bg-gradient-to-r from-blue-600 to-blue-800 text-white rounded-lg shadow-xl p-8"
        >
          <p className="text-lg text-center text-blue-100 max-w-4xl mx-auto">
            Hydrocawach Cavitation Systems deliver sustainable, high-performance bioprocess intensification,
            improving productivity while reducing energy and maintenance costs.
          </p>
        </motion.div>

      </div>
    </div>

    <WhatsAppConnect />
  </div>
);

export default BioreactorsAndFermentation;